<div class="app-container" [class.sidebar-collapsed]="isSidebarCollapsed">


    <!-- Mobile / Tablet overlay backdrop -->
    <div class="mobile-overlay"
         *ngIf="isMobileMenuOpen"
         (click)="closeMobileMenu()">
    </div>


    <!-- ═══════════════════════════════════
         FIXED HEADER
         ═══════════════════════════════════ -->
    <header class="app-header" role="banner">


        <!-- Hamburger — shown on tablet & mobile (hidden on desktop via CSS) -->
        <button class="hamburger-btn"
                (click)="toggleMobileMenu()"
                [class.open]="isMobileMenuOpen"
                aria-label="Toggle navigation menu"
                [attr.aria-expanded]="isMobileMenuOpen">
            <span class="hamburger-line"></span>
        </button>


        <!-- Page title -->
        <div class="header-title">
            <span class="title-text" title="{{ categoryName }}">{{ categoryName }}</span>
        </div>


        <!-- Header right section -->
        <div class="header-right">


            <!-- Available for Consultations toggle -->
           
            <div>
              <!-- <app-available-toggle></app-available-toggle> -->
            </div>

            <!-- support shortcut icon -->


            <a class="header-icon" title="Contact Support" href="#" onclick="window.open(
                'https://mail.google.com/mail/?view=cm&fs=1&to=support@lexiz.ai&su=Support%20Request',
                '_blank'
              ); return false;">
                <i class="material-icons icon-img">support_agent</i>
            </a>








            <!-- Notification bell -->
            <div class="header-icon"
                id="notification-icon"
                (click)="toggleNotifications()"
                title="Notifications"
                role="button"
                tabindex="0"
                [attr.aria-label]="notificationCount > 0 ? notificationCount + ' unread notifications' : 'Notifications'">


            <i class="material-icons icon-img" aria-hidden="true">notifications</i>


            <span class="notification-badge" *ngIf="notificationCount > 0" aria-hidden="true">
                {{ notificationCount }}
            </span>
            </div>




            <!-- User info: name + role + time — desktop only, hidden on tablet & mobile via CSS -->
            <div class="header-user-info"
                 aria-hidden="true"
                 (mouseenter)="isCardVisible = true"
                 (mouseleave)="isCardVisible = false">
                <p class="header-user-name" [ngClass]="{'solo-style': isSoloCategory}">{{ name }}</p>
                <p class="header-user-sub" *ngIf="!isSoloCategory">{{ role }}&nbsp;&bull;&nbsp;{{ currentTime }}</p>
            </div>


            <!-- User profile -->
            <div class="user-profile"
                 (mouseenter)="isCardVisible = true"
                 (mouseleave)="isCardVisible = false"
                 role="button"
                 tabindex="0"
                 aria-label="User profile menu"
                 [attr.aria-expanded]="isCardVisible">


                <ng-container *ngIf="profilePic; else initials">
                    <img [src]="profilePic" alt="Profile picture" class="profile-avatar" />
                </ng-container>
                <ng-template #initials>
                    <div class="profile-avatar" aria-hidden="true">{{ (userRole === 'AAM' ? firmName : name)[0] | uppercase }}</div>
                </ng-template>


                <!-- Profile dropdown card -->
                <div *ngIf="isCardVisible" class="profile-dropdown" role="menu">
                    <div class="dropdown-arrow" aria-hidden="true"></div>
                    <div class="dropdown-inner">

                    <div class="profile-info-section">
                        <div class="profile-avatar-large" aria-hidden="true">
                            <ng-container *ngIf="profilePic; else initialsLarge">
                                <img [src]="profilePic" alt="Profile picture" class="avatar-img" />
                            </ng-container>
                             <ng-template #initialsLarge>{{ (userRole === 'AAM' ? firmName : name)[0] | uppercase }}</ng-template>
                        </div>
                        <span class="profile-greeting" [routerLink]="['/profile']">Hi, {{ name }}!</span>
                        <p class="profile-email">{{ useremail }}</p>
                        <p class="profile-role-firm-name" *ngIf="!isSoloCategory">{{ role }}<ng-container *ngIf="!isSoloCategory"> | {{ firmName }}</ng-container></p>
                    </div>


                    <!-- Switch firms -->
                    <div *ngIf="hasMultipleFirms && availableFirms.length > 0" class="switch-firms-section">
                        <p class="section-label">Switch Firms</p>
                        <div class="firms-list">
                            <div *ngFor="let firm of availableFirms"
                                 class="firm-item"
                                 role="menuitem"
                                 tabindex="0"
                                 [class.disabled]="switchingFirmId !== ''"
                                 [class.loading]="switchingFirmId === firm.id"
                                 (click)="!switchingFirmId && switchFirm(firm)"
                                 (keyup.enter)="!switchingFirmId && switchFirm(firm)">
                                <div class="firm-avatar">{{ firm.firmName?.charAt(0) || firm.name?.charAt(0) || 'F' }}</div>
                                <div class="firm-info">
                                    <p class="firm-name">{{ firm.firmName || firm.name }}</p>
                                </div>
                                <div *ngIf="switchingFirmId === firm.id" class="loading-spinner">
                                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                                </div>
                            </div>
                        </div>
                    </div>


                    <!-- Logout -->
                    <button type="button" class="logout-btn" (click)="logout()" role="menuitem">
                        <i class="fa fa-sign-out" aria-hidden="true"></i>&nbsp;&nbsp;Log out
                    </button>
                    </div><!-- /.dropdown-inner -->
                </div>
            </div>
        </div>
    </header>


    <!-- ═══════════════════════════════════
         SIDEBAR — driven by activeNavItems
         Works for all products
         ═══════════════════════════════════ -->
    <aside class="app-sidebar"
           [class.collapsed]="isSidebarCollapsed"
           [class.mobile-open]="isMobileMenuOpen"
           role="navigation"
           aria-label="Main navigation">


        <!-- Sidebar header row -->
        <div class="sidebar-header">


            <!-- ── Expanded state: logo + product name + collapse button (Desktop) ── -->
            <ng-container *ngIf="!isSidebarCollapsed && !isMobileMenuOpen">
                <div class="sidebar-brand" title="Dashboard" role="button" tabindex="0" routerLink="/grid" (click)="getCategory('Dashboard'); getData();">
                    <img class="sidebar-logo"
                         [src]="currentProduct.logo"
                         [alt]="currentProduct.name + ' logo'" />
                    <span class="sidebar-product-name">{{ currentProduct.name }}</span>
                </div>
                <button class="collapse-btn"
                        (click)="toggleSidebar()"
                        title="Collapse sidebar"
                        aria-label="Collapse sidebar">
                    <i class="material-icons" aria-hidden="true">chevron_left</i>
                </button>
            </ng-container>


            <!-- ── Mobile/Tablet: logo + product name + close button ── -->
            <ng-container *ngIf="isMobileMenuOpen">
                <div class="sidebar-brand" title="Dashboard" role="button" tabindex="0" routerLink="/grid" (click)="getCategory('Dashboard'); getData(); closeMobileMenu();">
                    <img class="sidebar-logo"
                         [src]="currentProduct.logo"
                         [alt]="currentProduct.name + ' logo'" />
                    <span class="sidebar-product-name">{{ currentProduct.name }}</span>
                </div>
                <button class="close-btn"
                        (click)="closeMobileMenu()"
                        title="Close menu"
                        aria-label="Close menu">
                    <i class="material-icons" aria-hidden="true">close</i>
                </button>
            </ng-container>


            <!-- ── Collapsed / icon-only state: logo mark only ── -->
            <ng-container *ngIf="isSidebarCollapsed && !isMobileMenuOpen">
                <div class="sidebar-logo-collapsed" title="Dashboard" role="button" tabindex="0" routerLink="/grid" (click)="getCategory('Dashboard'); getData();">
                    <img class="sidebar-logo-icon"
                         [src]="currentProduct.logoIcon"
                         [alt]="currentProduct.name + ' logo'" />
                </div>
            </ng-container>


        </div>


        <!-- Nav list — rendered from activeNavItems getter (works for all products) -->
        <nav class="sidebar-nav">
            <ul class="nav-list" role="menubar">


                <ng-container *ngFor="let item of activeNavItems">


                    <!-- ── Plain nav item (no submenu) ── -->
                    <li class="nav-item" *ngIf="!item.children" role="none">
                        <a class="nav-link"
                           [class.active]="isActive(item.id) || router.url.startsWith(item.link)"
                           [routerLink]="item.link"
                           (click)="getCategory(item.name); closeMobileMenu();"
                           (mouseenter)="showTooltip($event, getNavItemName(item))"
                           (mouseleave)="hideTooltip()"
                           role="menuitem"
                           [attr.aria-label]="getNavItemName(item)"
                           [attr.aria-current]="isActive(item.id) ? 'page' : null">
                            <i class="material-icons nav-icon" aria-hidden="true">{{ item.icon }}</i>
                            <!-- Show label when: sidebar expanded on desktop OR drawer is open on tablet/mobile -->
                            <span class="nav-label"
                                  *ngIf="!isSidebarCollapsed || isMobileMenuOpen">{{ getNavItemName(item) }}</span>
                        </a>
                    </li>


                    <!-- ── Nav item WITH submenu ── -->
                    <li class="nav-item has-submenu" *ngIf="item.children" [class.expanded]="expandedItem === item.name" role="none">
                    
                        <a class="nav-link" [class.active]="isParentActive(item)" (click)="toggleSubmenu(item.name); item.children ? router.navigate([item.children[0].route], {queryParams: item.children[0].profileType ? {profileType: item.children[0].profileType} : {}}) : (item.link && router.navigate([item.link]))"
                            (mouseenter)="showSubmenuPopover($event, getNavItemName(item), item.children)" (mouseleave)="hideSubmenuPopover()"
                            role="menuitem" [attr.aria-label]="getNavItemName(item)" [attr.aria-haspopup]="true"
                            [attr.aria-expanded]="expandedItem === item.name">
                            
                    
                            <i class="material-icons nav-icon" aria-hidden="true">{{ item.icon }}</i>
                    
                            <span class="nav-label" *ngIf="!isSidebarCollapsed || isMobileMenuOpen">
                                {{ getNavItemName(item) }}
                            </span>
                    
                            <i class="material-icons submenu-arrow" *ngIf="!isSidebarCollapsed || isMobileMenuOpen" aria-hidden="true">
                                {{ expandedItem === item.name ? 'expand_less' : 'expand_more' }}
                            </i>
                        </a>
                    
                        <!-- First Level Submenu -->
                        <ul class="submenu" *ngIf="expandedItem === item.name && (!isSidebarCollapsed || isMobileMenuOpen)" role="menu">
                    
                            <li class="submenu-item" *ngFor="let child of item.children" role="none">
                    
                                <!-- Normal child item -->
                                <a *ngIf="!child.children" [routerLink]="child.route" [queryParams]="child.profileType ? {profileType: child.profileType} : null" (click)="getCategory(child.label); closeMobileMenu();"
                                    [class.active]="(router.url.split('?')[0] === child.route && (!child.profileType || router.url.includes('profileType=' + child.profileType))) || (child.activeId && isActive(child.activeId))" role="menuitem"
                                    [attr.aria-current]="router.url.split('?')[0] === child.route ? 'page' : null">
                                    {{ child.label }}
                                </a>

                    
                                <!-- Child item with nested submenu -->
                                <ng-container *ngIf="child.children">
                    
                                <a class="submenu-link" [routerLink]="child.route"
                                    (click)="toggleNestedSubmenu(child.label); getCategory(child.label); closeMobileMenu()"
                                    [class.active]="router.url === child.route || expandedNestedItem === child.label || isNestedChildActive(child.children)"
                                    role="menuitem">
                                
                                    {{ child.label }}
                                
                                    <i class="material-icons submenu-arrow sub2" aria-hidden="true">
                                        {{ expandedNestedItem === child.label ? 'expand_less' : 'expand_less' }}
                                    </i>
                                </a>

                                    <!-- Second Level Submenu -->
                                    <ul class="submenu nested-submenu" *ngIf="expandedNestedItem === child.label" role="menu">
                    
                                        <li class="submenu-item" *ngFor="let subChild of child.children" role="none">
                                            <a [routerLink]="subChild.route" (click)="getCategory(subChild.label); closeMobileMenu();"
                                                [class.active]="router.url === subChild.route" role="menuitem" class="subalign"
                                                [attr.aria-current]="router.url === subChild.route ? 'page' : null">
                                                {{ subChild.label }}
                                            </a>
                                        </li>
                                    </ul>

                                </ng-container>

                            </li>
                    </ul>
                </li>



                </ng-container>
                <li class="nav-item logout-item" role="none">
                    <a
                        class="nav-link logout-link"
                        role="menuitem"
                        tabindex="0"
                        aria-label="Log out"


                        (click)="logout()"
                        (keyup.enter)="logout()"
                        (mouseenter)="showTooltip($event, 'Logout')"
                        (mouseleave)="hideTooltip()"
                        (focus)="showTooltip($event, 'Logout')"
                        (blur)="hideTooltip()"
                    >
                        <i class="material-icons nav-icon" aria-hidden="true">logout</i>


                        <!-- Label visible only when expanded or mobile -->
                        <span
                        class="nav-label"
                        *ngIf="!isSidebarCollapsed || isMobileMenuOpen"
                        >
                        Log out
                        </span>
                    </a>
                </li>


            </ul>
        </nav>


        <!-- Desktop expand button (floating pill, shown when icon-only) -->
        <button class="expand-btn"
                *ngIf="isSidebarCollapsed && !isMobileMenuOpen"
                (click)="toggleSidebar()"
                title="Expand sidebar"
                aria-label="Expand sidebar">
            <i class="material-icons" aria-hidden="true">chevron_right</i>
        </button>
    </aside>


    <!-- ═══════════════════════════════════
         MAIN CONTENT
         ═══════════════════════════════════ -->
    <main class="app-main"
          [class.sidebar-collapsed]="isSidebarCollapsed"
          role="main">
        <router-outlet></router-outlet>
    </main>
</div>


<!-- ═══════════════════════════════════
     TOOLTIP — desktop icon-only sidebar
     ═══════════════════════════════════ -->
<div class="sidebar-tooltip"
     *ngIf="tooltipVisible && isSidebarCollapsed && !isMobileMenuOpen"
     [style.top.px]="tooltipTop"
     [style.left.px]="tooltipLeft"
     role="tooltip">
    {{ tooltipText }}
</div>


<!-- ═══════════════════════════════════
     SUBMENU POPOVER — desktop icon-only sidebar
     ═══════════════════════════════════ -->
<div class="submenu-popover"
     *ngIf="submenuPopoverVisible && isSidebarCollapsed && !isMobileMenuOpen"
     [style.top.px]="popoverTop"
     [style.left.px]="popoverLeft"
     (mouseenter)="keepPopoverVisible()"
     (mouseleave)="hideSubmenuPopover()"
     role="menu">
    <div class="popover-arrow" aria-hidden="true"></div>
    <div class="popover-header">{{ popoverTitle }}</div>
    <div class="popover-divider" aria-hidden="true"></div>
    <ul class="popover-menu" role="menubar">
        <li *ngFor="let item of popoverItems"
            class="popover-item"
            role="menuitem"
            tabindex="0"
            (click)="navigateToSubmenu(item)"
            (keyup.enter)="navigateToSubmenu(item)">
            {{ item.label }}
        </li>
    </ul>
</div>


<!-- T&C Overlay dialog -->
<div class="terms-overlay" *ngIf="showTermsModal">
    <div class="terms-dialog">
        <div class="terms-header">
            <h2>Terms & Conditions</h2>
        </div>

        <div class="terms-body">
            <iframe *ngIf="safeTermsUrl" [src]="safeTermsUrl" class="terms-iframe"></iframe>

            <div *ngIf="!safeTermsUrl" class="no-preview">
                <p>Unable to load document.</p>
                <a [href]="termsUrl" target="_blank">Open Terms</a>
            </div>
        </div>

        <div class="terms-footer">
            <div class="checkbox-section">
                <input type="checkbox" id="agreeCheck" [(ngModel)]="isChecked" />
                <!-- <label for="agreeCheck">By clicking this, to agree the Terms & Conditions, <a href="https://digicoffer.com/digicoffer_privacy.pdf">Privacy Policies</a> & <a href="https://digicoffer.com/digicoffer_cookie.pdf">Cookies</a></label> -->
                &nbsp;<label for="agreeCheck">
                    By clicking this, you agree to the
                    <a style="text-decoration: underline;" href="https://digicoffer.com/digicoffer_privacy.pdf" target="_blank">Privacy Policy</a>
                    and
                    <a style="text-decoration: underline;" href="https://digicoffer.com/digicoffer_cookie.pdf" target="_blank">Cookies Policy</a>,
                    along with the Terms & Conditions.
                </label>

            </div>

            <!-- Buttons -->
            <div class="action-buttons">
                <button class="btn cancel-btn" (click)="cancelTerms()">
                    Cancel
                </button>

                <button class="btn agree-btn" [disabled]="!isChecked" (click)="agreeTerms()">
                    Agree & Continue
                </button>
            </div>

        </div>

    </div>
</div>